import axios from "axios";

// Quotation CRUD
export const createQuotation = async (data) => {
  const response = await axios.post("quotation", data);
  return response.data;
};

export const getAllQuotations = async (params = {}) => {
  const response = await axios.get("quotation", { params });
  return response.data;
};

export const getQuotationById = async (id) => {
  const response = await axios.get(`quotation/${id}`);
  return response.data;
};

export const updateQuotation = async (id, data) => {
  const response = await axios.put(`quotation/${id}`, data);
  return response.data;
};

export const deleteQuotation = async (id) => {
  const response = await axios.delete(`quotation/${id}`);
  return response.data;
};

// Quotation Actions
export const sendQuotation = async (id) => {
  const response = await axios.post(`quotation/${id}/send`, {});
  return response.data;
};

export const updateQuotationStatus = async (id, status) => {
  const response = await axios.patch(`quotation/${id}/status`, { status });
  return response.data;
};

export const convertToOrder = async (id, data = {}) => {
  const response = await axios.post(`quotation/${id}/convert`, data);
  return response.data;
};

export const createRevision = async (id) => {
  const response = await axios.post(`quotation/${id}/revision`, {});
  return response.data;
};

// Quotation PDF
export const getQuotationPDF = async (id) => {
  const response = await axios.get(`quotation/${id}/pdf`, {
    responseType: "blob",
  });
  return response.data;
};

export default {
  createQuotation,
  getAllQuotations,
  getQuotationById,
  updateQuotation,
  deleteQuotation,
  sendQuotation,
  updateQuotationStatus,
  convertToOrder,
  createRevision,
  getQuotationPDF,
};
